import styled from 'styled-components';
import { breakpoints } from 'config/config';
export const StyledAllFarmsPage = styled('div')`
  background-color: ${(props) => props.theme.greyBackground};

  .products-filters-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    max-width: 1482px;
    padding: 0 20px;
    margin: 0 auto;
    gap: 50px;

    .ant-spin-nested-loading {
      width: 100%;
      display: flex;
      justify-content: center;
    }

    .products-wrapper {
      width: 100%;

      .products {
        padding-top: 40px;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
        gap: 32px 20px;
      }

      .pagination {
        display: flex;
        justify-content: center;
        padding: 50px 0;

        li {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 0;
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          font-family: ${({ theme }) => theme.fontText} !important;
        }
      }
    }

    .ant-select-arrow {
      color: ${(props) => props.theme.stepArrowColor};
    }

    .form-container {
      margin-top: 40px;
    }
  }

  .ant-pagination-item-active,
  .ant-pagination-item-active:hover {
    background-color: ${(props) => props.theme.brand01};
    border-color: ${(props) => props.theme.brand01};
  }

  .ant-pagination-prev {
    margin-inline-end: 0;
    margin-right: 24px;
  }

  .ant-pagination-next {
    margin-left: 16px;
  }

  .ant-pagination-item-link span {
    color: ${(props) => props.theme.paginationLink};
  }

  .ant-pagination-item-active a,
  .ant-pagination-item-active:hover a {
    color: ${(props) => props.theme.white};
  }

  .banners {
    padding-top: 80px;
    padding-bottom: 39px;
    background-color: ${({ theme }) => theme.white};

    .slick-slider {
      margin-bottom: 0;

      .banner-image-wrapper {
        padding: 0;
      }

      .slick-dots-bottom {
        bottom: -32px;
      }
    }
    .banner-wrapper {
      padding: 21px 0;
    }
  }

  .products-filters-container {
    .ant-select-selector {
      border: 1px solid ${({ theme }) => theme.borderBottom};
    }

    .ant-select-selection-placeholder {
      color: ${({ theme }) => theme.colorText} !important;
      font-size: 16px;
      line-height: 28px;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .products-filters-container {
      .form-container {
        display: none;
      }

      .form-container {
        padding: 0 20px 0 20px;
      }

      .products-wrapper {
        padding: 0 20px 0 20px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    background-color: ${(props) => props.theme.brightGrey};

    .products-filters-container {
      padding: 0;

      .products-wrapper {
        padding: 0;

        .products {
          gap: 24px;
          padding: 12px 16px 0;
          grid-template-columns: minmax(0, 1fr);
        }

        .pagination {
          padding: 15px 0 44px 0;
        }
      }

      .pagination {
        padding: 15px 0 39px 0 !important;
      }
    }

    .banners {
      padding-top: 25px;
      padding-bottom: 21px;
      background-color: ${({ theme }) => theme.brightGrey};

      .desktop-banner {
        display: block;
      }

      .slick-dots {
        display: none !important;
      }

      .banner-wrapper {
        padding-bottom: 0;
      }

      .desktop-banner:first-child {
        padding-top: 0;
      }
    }
  }
`;
